import { apiRequest } from './client';
import type { HubRepository } from '../../application/ports/HubRepository';
import type { ClaimedHub, Hub, HubCommand } from '../../domain/Hub';

export class HttpHubRepository implements HubRepository {
  list() {
    return apiRequest<{ hubs: Hub[] }>('/hubs');
  }

  claim(input: { hubId: string; code: string; siteId?: string | null }) {
    return apiRequest<ClaimedHub>('/hubs/claim', { method: 'POST', body: JSON.stringify(input) });
  }

  setSite(id: string, siteId: string | null) {
    return apiRequest<{ hub: Hub }>(`/hubs/${id}`, { method: 'PATCH', body: JSON.stringify({ siteId }) });
  }

  command(id: string, command: HubCommand, seconds?: number) {
    return apiRequest<{ hubOnline: boolean }>(`/hubs/${id}/commands`, {
      method: 'POST',
      body: JSON.stringify({ command, segundos: seconds }),
    });
  }
}
